import { motion } from "framer-motion";

import { revealContainer, fadeUp } from "../lib/motionVariants";

export default function Contact() {
  return (
    <motion.section
      id="contact"
      variants={revealContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      className="border-t border-ink pb-8 pt-10 md:pb-16 md:pt-20"
    >
      <div className="grid grid-cols-1 items-end gap-6 md:grid-cols-2 md:gap-16">
        <motion.div variants={fadeUp}>
          <span className="font-mono text-[11px] tracking-[0.2em] text-primary">05</span>
          <h2 className="mt-3.5 font-reactor text-[clamp(34px,6vw,84px)] font-bold leading-[0.92] [font-variation-settings:'wdth'_7]">
            LET’S GET<br />YOU ONLINE.
          </h2>
        </motion.div>

        <motion.div variants={fadeUp}>
          <p className="max-w-[44ch] text-lg leading-normal text-ink-600">
            Send a note with your foundry, how many families you have, and when you want to launch.
            You will hear back from one of us — not a form robot.
          </p>

          <a
            href="mailto:hi@found-foundry.com"
            className="mt-5 inline-block border-b-2 border-primary font-reactor text-[clamp(22px,2.6vw,34px)] font-bold [font-variation-settings:'wdth'_4] transition-colors duration-200 hover:text-primary"
          >
            hi@found-foundry.com
          </a>

          <div className="mt-6 flex gap-5 font-mono text-[11px] uppercase tracking-[0.14em]">
            <a href="https://www.instagram.com/found-foundry" target="_blank" rel="noreferrer" className="text-ink transition-colors duration-200 hover:text-primary">Instagram ↗</a>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}
